import script from "./DownloadView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadView.vue?vue&type=script&setup=true&lang=ts"

import "./DownloadView.vue?vue&type=style&index=0&id=3280fc35&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\iab_b\\Documents\\Dev\\OA\\woah-transfer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3280fc35"]])

export default __exports__